import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Fetch } from "../../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { JVInput } from "../../../shared/JVInput";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";

interface IProps {
    open: boolean;
    singleData: ILeadScrappingJobs;
    hideDialog: () => void;
    toast: any;
}

interface ILeadScrappingJobs {
    companyName?: string,
    companyUrl?: string,
    createdAt?: Date,
    createdBy?: number,
    id?: number,
    jobDescription?: string,
    jobTitle?: string,
    jobType?: string,
    jobUrl?: string,
    pocCount?: number,
    source?: string,
    pocs?: any[]
}

interface IBlacklistMast {
    companyName?: string,
    reason?: string,
}

const schema = yup.object({
    companyName: yup.string().nullable(),
    reason: yup.string().nullable(),
});

export const BlacklistRequestForm = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [reason, setReason] = useState<string>("");

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IBlacklistMast>({
        resolver: yupResolver(schema),
        defaultValues: {
            companyName: "",
            reason: ""
        },
        shouldFocusError: false,
    });

    const saveToDB = async (body: any) => {

        if (reason.trim() === "") {
            props.toast.current.show({ severity: "error", detail: "Reason can not be empty.", life: 3000 });
            return;
        }

        const newBody = {
            companyName: body.companyName,
            reason: reason
        };

        setLoading(true);

        const response = await Fetch(`lead-capture/requestBlacklistCompany`, "POST", newBody, null, props.toast);
        if (response) {
            setLoading(false);
            props.toast.current.show({ severity: "success", detail: "Added Successfully.", life: 3000 });
            onHide();
        } else setLoading(false);
    };

    function onSubmit(data: any) {
        saveToDB(data);
    }

    const onHide = () => {
        setReason("");
        reset();
        props.hideDialog();
    };

    const header = () => {
        return <span>Request to Blacklist Company</span>;
    };

    useEffect(() => {
        if (props.open) {
            reset({ companyName: props.singleData.companyName, reason: "" });
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: "80vw", overflowY: "scroll" }} header={header} className="p-fluid" onHide={onHide} draggable={false}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required disabled column={3} label="Company" control={control} name="companyName" error={errors.companyName?.message} />
                <div className={`field col-12 md:col-12`}>
                    <label>{"Reason"}{<span style={{ color: 'red' }}>*</span>}</label>
                    <InputTextarea value={reason} onChange={(e) => setReason(e.target.value)} rows={5} cols={30} />
                </div>
                <div className="col-12 md:col-12" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "10px", }} >
                    <Button className="field col-12 md:col-6  h-2rem" label="SEND" type="submit" loading={loading} ></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLOSE" onClick={onHide} type="button" ></Button>
                </div>
            </form>
        </Dialog>
    );
}